import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import moment from 'moment';

import {START_DATE, END_DATE} from '../../actions/index';

class DateRangeFilter extends Component {
	handleChangeStart( date ) {
		const startDate = moment( date.target.value )
			.format( 'YYYY-MM-DD' );
		this.props.dispatch( {
			                     type: START_DATE, payload: startDate
		                     } );
	}

	handleChangeEnd( date ) {
		const endDate = moment( date.target.value )
			.format( 'YYYY-MM-DD' );
		this.props.dispatch( {
			                     type: END_DATE, payload: endDate
		                     } );
	}

	render() {
		return (<Fragment>
				<div className="col-md-1 hidden-sm hidden-xs">
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_4106_1332)">
							<path d="M11.6667 20C11.4864 20 11.311 19.9415 11.1667 19.8333L7.8334 17.3333C7.7299 17.2557 7.6459 17.1551 7.58804 17.0393C7.53019 16.9236 7.50007 16.796 7.50007 16.6667V11.9833L1.6534 5.40583C1.23817 4.9374 0.967048 4.35901 0.872632 3.7402C0.778216 3.12138 0.864519 2.48846 1.12117 1.91751C1.37782 1.34656 1.79389 0.861882 2.31938 0.521721C2.84487 0.181561 3.45742 0.000395349 4.0834 0L15.9167 0C16.5427 0.000734209 17.1551 0.182199 17.6803 0.522589C18.2056 0.862978 18.6214 1.34781 18.8778 1.91882C19.1342 2.48983 19.2202 3.12273 19.1255 3.74146C19.0309 4.36018 18.7596 4.93841 18.3442 5.40667L12.5001 11.9833V19.1667C12.5001 19.3877 12.4123 19.5996 12.256 19.7559C12.0997 19.9122 11.8877 20 11.6667 20Z" fill="#00549E"/>
						</g>
						<defs>
							<clipPath id="clip0_4106_1332">
								<rect width="20" height="20" fill="white"/>
							</clipPath>
						</defs>
					</svg>
				</div>
				<div className="form-group-from-date form-group input-group col-sm-12 col-md-3">
					<label className="control-label"
					       htmlFor="date-from">From:</label>
					<input
						type="date"
						className="form-control date-from"
						onChange={ this.handleChangeStart.bind( this ) }
						name="date_from"
						value={ this.props.dateRange.startDate }
						placeholder="mm/dd/yyyy"
						data-minlength="3"
					/>
				</div>
				<div className="form-group-to-date form-group input-group col-sm-12 col-md-3">
					<label className="control-label" htmlFor="date-to">To:</label>
					<input
						type="date"
						className="form-control date-to"
						onChange={ this.handleChangeEnd.bind( this ) }
						name="date_to"
						value={ this.props.dateRange.endDate }
						placeholder="mm/dd/yyyy"
						data-minlength="3"
					/>
				</div>
			</Fragment>
		);
	}
}

function mapStateToProps({dateRange}) {
	return {dateRange};
}

export default connect(mapStateToProps)(DateRangeFilter);
